import { baseURL } from "./APIPath";
import { mockData } from "./mockApi";

const backendUrl = baseURL; // JHipster backend URL (placeholder)

const apiCall = async (
  endpoint,
  useMock,
  method = "GET",
  body = null,
  startLoading,
  stopLoading,
  displayToast
) => {
  if (startLoading)
    startLoading(); // Activate global loader
  try {
    if (useMock) {
      return mockData(method, endpoint, body);
    } else {
      console.log(`[LIVE API] ${method} ${backendUrl}${endpoint}`, body || "");
      const storedToken = sessionStorage.getItem("keycloak_access_token");

      const isPatch = method === "PATCH";
      const options = {
        method: method,
        headers: {
          "Content-Type": isPatch
            ? "application/merge-patch+json"
            : "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${storedToken}`,
          "question-app-token": sessionStorage.getItem("app_masterdata_token"),
        },
      };

      // Only include body for non-GET/HEAD requests
      if (method !== "GET" && method !== "HEAD" && body) {
        options.body = JSON.stringify(body);
      }

      const response = await fetch(`${backendUrl}${endpoint}`, options);

      if (!response.ok) {
        // If response is not ok, attempt to parse text then JSON for a more detailed error
        let errorText = "";
        try {
          errorText = await response.text();
        } catch (e) { }

        let errorData = null;
        try {
          errorData = errorText ? JSON.parse(errorText) : null;
        } catch (e) { }

        let errorMessage = `HTTP error! status: ${response.status}`;

        if (errorData) {
          // Prefer backend-provided fields
          const title = errorData.title || errorData.error || null;
          const detail = errorData.detail || errorData.message || null;
          const requested = errorData.requestedQuestions;
          const received = errorData.receivedQuestions;
          const shortfall = errorData.shortfall;

          const parts = [];
          if (title) parts.push(title);
          if (detail && detail !== title) parts.push(detail);
          if (
            typeof requested !== "undefined" &&
            typeof received !== "undefined" &&
            typeof shortfall !== "undefined"
          ) {
            parts.push(
              `Requested: ${requested}, Received: ${received}, Shortfall: ${shortfall}`
            );
          }
          if (parts.length > 0) {
            errorMessage = parts.join(" | ");
          }
        } else if (errorText) {
          errorMessage = errorText;
        }

        throw new Error(errorMessage);
      }
      if (method === "DELETE") return { success: true };
      return await response.json();
    }
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    // The displayToast will now use the more generic message from the apiCall
    displayToast(
      `Failed to fetch data: ${error.message}`,
      "error"
    );
    throw error; // Re-throw to be caught by calling component
  } finally {
    if (stopLoading)
      stopLoading(); // Deactivate global loader
  }
};
export default apiCall;
